var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#171719"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9389 31.9991C16.2003 31.922 12.5091 28.3755 12.5788 23.9679C12.6484 19.5158 16.4426 16.0302 21.1078 16.0992C25.2034 16.159 29.3535 19.2018 29.3296 24.33C29.3096 28.5679 25.4038 32.0726 20.9389 31.9991Z",
    fill: "#858B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45087 28.5761C7.92901 28.5761 7.44532 28.646 6.99216 28.5625C5.85305 28.3528 5.0469 27.4145 5.02018 26.3074C4.99538 25.2964 4.99442 24.2837 5.02018 23.2728C5.05262 21.9914 6.09824 20.9995 7.44628 20.9333C7.58843 20.926 7.73058 20.9324 7.83552 20.9324C9.97063 14.5392 14.3859 10.9982 21.5373 11C24.5463 11 27.2328 12.0872 29.5501 13.9312C31.8665 15.7743 33.3348 18.1201 34.0303 20.8897C34.3823 20.9287 34.7009 20.9378 35.0081 21.0013C36.1501 21.2409 36.9515 22.1439 36.9801 23.2582C37.0068 24.2692 37.0087 25.2819 36.9801 26.2929C36.9439 27.6341 35.8162 28.6387 34.409 28.6233C33.04 28.6087 31.9886 27.5815 31.9428 26.242C31.8971 24.8708 31.9467 23.4851 31.7482 22.1339C31.089 17.6609 26.9743 13.9593 22.2385 13.472C16.1337 12.8431 10.6575 17.0955 10.1328 22.9188C10.0164 24.2084 10.0317 25.5142 10.0718 26.8101C10.1195 28.3819 11.3759 29.5335 13.0331 29.6251C13.698 29.6623 14.1331 30.0453 14.1273 30.588C14.1216 31.1506 13.6522 31.5463 12.9682 31.5172C11.0325 31.4346 9.60906 30.5544 8.65694 28.9627C8.57871 28.832 8.50906 28.6977 8.4337 28.5652C8.42702 28.5534 8.40984 28.547 8.44896 28.5761H8.45087Z",
    fill: "#858B9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_3788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 21,
    fill: "white",
    transform: "translate(5 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.30285b4f9b5a6c74eb816e5395fb32f5.svg";
export { ForwardRef as ReactComponent };